import { Heart, Coffee, ExternalLink } from "lucide-react";
import { Reveal } from "@/lib/motion";

// PayPal.Me link — kann bei Bedarf hier ausgetauscht werden.
const PAYPAL_URL = "https://paypal.me/SebastianMenzel330";

export default function SupportProject() {
  return (
    <section id="unterstuetzen" data-testid="support-project-section" className="border-b border-white/10">
      <Reveal>
        <div className="mx-auto grid max-w-6xl grid-cols-1 gap-10 px-5 py-20 lg:grid-cols-[1fr_1.2fr] lg:gap-20 lg:px-8 lg:py-24">
          <div>
            <p className="mb-3 flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-[#8B5CF6]">
              <Heart className="h-3.5 w-3.5 fill-current" />
              Entwicklung unterstützen
            </p>
            <h3 className="font-display text-3xl font-bold tracking-tighter text-white sm:text-4xl">
              FestivalPlan unterstützen
            </h3>
          </div>
          <div>
            <p className="text-base leading-relaxed text-white/65">
              FestivalPlan ist kostenlos und soll es auch bleiben.{" "}
              <span className="text-[#EF4444]">❤</span>
              <br />
              Wenn dir FestivalPlan gefällt und du die weitere Entwicklung unterstützen möchtest,
              kannst du mir freiwillig eine kleine Unterstützung über PayPal zukommen lassen.
              Jeder Beitrag hilft dabei, FestivalPlan weiterzuentwickeln, neue Funktionen
              umzusetzen und die laufenden Kosten zu decken.
            </p>
            <p className="mt-4 text-sm text-white/45">Vielen Dank für deine Unterstützung. 🙏</p>
            <a
              href={PAYPAL_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="paypal-support-btn"
              className="btn-primary group mt-8 inline-flex items-center gap-2.5 px-6 py-3 text-sm font-medium"
            >
              <Coffee className="h-4 w-4" />
              FestivalPlan unterstützen
              <ExternalLink className="h-4 w-4 opacity-70 transition-transform group-hover:translate-x-0.5" />
            </a>
            <p className="mt-5 text-xs text-white/35">
              Deine Unterstützung ist vollständig freiwillig. Durch eine Zahlung werden keine
              zusätzlichen Funktionen, Inhalte oder Vorteile freigeschaltet.
            </p>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
